/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import * as React from "react";
import { Button } from "../../../components/ui/button";
import { useNrCellsData } from "./hooks";
import { prepareNrCellDataGrid, prepareRadioNodeDataGrid, tableContainerSxProps } from "../helpers";
import { RadixSelectControl } from "../../../components/ui/radix-select";
import { STATUSLIST } from "../../../globals/globals";
import { useStoreDispatch } from "../../../store/hooks";
import "../Config.css";
import { Icon } from "../../../components/Shared/Icon";
import CustomDataGrid from "../../../components/Shared/Table/CustomDataGrid";
import { useSelector } from "react-redux";
import { confirmDialogSelector } from "../../../store/helpers/helperSelectors";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import { IDusNodeDataGridRow, IFullDeviceDetails, INrCell, INrCellDataGridRow, IRadioNodesDataGridRow } from "../../../store/api/deviceConfig/types";
import { setConfirmDialog } from "../../../store/helpers/helperReducers";
import { DIALOGOPENFOR } from "../../../globals/globals";
import ConfirmDialog from "../../../components/Shared/Dialogs/ConfirmDialog";
import { constStr } from "../../../globals/constants";
import Actions from "../../../components/Actions/Actions";
import { prepareActionProps } from "../../../components/Actions/ActionHelper";
import { isOpenRnCuDrawerSelector, noOfSelectedRowSelector, selectedDeviceSelector } from "../../../store/api/devices/selectors";
import { nrCellOptions } from "../../../components/Actions/ActionOptions";
import { setNoOfSelectedRow, setOpenRnCuDrawer, setSelectedRadioNodeRow } from "../../../store/api/devices/reducers";
import { GridEventListener } from "@mui/x-data-grid";
import { GridCellParams } from "@mui/x-data-grid";
import CuDrawer from "../RadioNode/CuDrawer";

const NrCells: React.FC = () => {
  const dispatch = useStoreDispatch();
  const {
    permissions,
    data,
    isLoading,
    nrCellsColumns,
    setStatus,
    selectedNrCellDetails,
    setSelectedNrCellDetails,
    rowClicked,
    setRowClicked,
    deleteNrCellHandler,
    setSelectedNrCellRow,
    zoneList,
    radioNodeList,
  } = useNrCellsData();

  const getDataFromApi: INrCell[] = data?.data || [];
  const rowsData = prepareNrCellDataGrid(getDataFromApi, zoneList?.data || []) || [];
  const noOfRows = data?.totalItems || 0;
  // const [NoOfSelectedRow, setNoOfSelectedRow] = React.useState(0);
  const [selectedRow, setSelectedRow] = React.useState<INrCellDataGridRow>();

  const openConfirmDialog = useSelector(confirmDialogSelector);
  const selectedDevice: IFullDeviceDetails = useSelector(selectedDeviceSelector);
  const isOpenRnCuDrawer = useSelector(isOpenRnCuDrawerSelector);

  const [radioNodeFormData, setRadioNodeFormData] = React.useState<IRadioNodesDataGridRow | undefined>(undefined);
  //const [duFormData, setDuFormData] = React.useState<IDusNodeDataGridRow | undefined>(undefined);

  const getRnListFromApi = radioNodeList?.data || [];
  const radioNodesList = getRnListFromApi?.filter((el) => el?.ethernetId !== null) || [];
  const rowsDataRns: Array<IRadioNodesDataGridRow> = prepareRadioNodeDataGrid(radioNodesList) || [];
  const { nrCellRowIds = [] } = useSelector(noOfSelectedRowSelector);
  
  const actionProps = prepareActionProps(selectedDevice?.objectKey!, selectedDevice.name, selectedRow, nrCellOptions, "NrCells", false, null);

  const isOfflineDevice = selectedDevice?.configurationStatus?.toLowerCase() === "offline";

  const statusOptions = [
    { value: "__placeholder__", label: "STATUS" },
    ...STATUSLIST.map((s) => ({ value: s, label: s })),
  ];
  const [statusValue, setStatusValue] = React.useState("__placeholder__");
  const handleOnStatusSelect = (val: string) => {
    setStatusValue(val);
    setStatus(val === "__placeholder__" ? "" : val);
  };

  //const rnListData = selectedDevice?.modelName?.toLowerCase() !== "SCSN-10000-3"?.toLowerCase() ? rowsDataRns : rowsDataDus

  const handleOnRowSelected = (rowIds: GridRowSelectionModel) => {
    dispatch(setNoOfSelectedRow({ nrCellRowIds: rowIds }));
    const rowIdLength = rowIds?.length;
    //setNoOfSelectedRow(rowIdLength);
    if (rowIdLength === 1) {
      setSelectedRow(() => rowsData.filter((item) => item.id === rowIds[0])[0]);
      setSelectedNrCellRow(() => rowsData.filter((item) => item.id === rowIds[0])[0]);
    }
  };

  const handleCellClicked: GridEventListener<"cellClick"> = (params: GridCellParams<any>) => {
    if (!permissions?.hasOpCodeGroup("view_topology")) return;
    if (params?.field?.toLowerCase() === "radionode" && !!params?.value) {
      if (Array.isArray(getDataFromApi) && getDataFromApi?.length > 0 && params?.row?.id) {
        let selectedLteCell = getDataFromApi?.filter((el) => el?.index === params?.row?.id?.toString());
        if (selectedLteCell?.length > 0) {
          let arr = rowsDataRns?.filter((el) => el?.id === Number(selectedLteCell[0]?.radioNode)) || [];
          if (arr?.length > 0 && arr[0]?.model?.toLowerCase() !== "unknown" && !!arr[0]?.model) {
            setRadioNodeFormData(arr[0]);
            dispatch(setSelectedRadioNodeRow(arr[0]));
            setSelectedNrCellDetails(selectedLteCell[0]);
            dispatch(setOpenRnCuDrawer(true));
            setRowClicked(true);
          }
        }
      }
    } else return;
  };

  // const handleCellClicked: GridEventListener<"cellClick"> = (params: GridCellParams<any>) => {
  //   if (params?.field?.toLowerCase() === "radionode" && !!params?.value) {
  //     if (Array.isArray(getDataFromApi) && getDataFromApi?.length > 0 && params?.row?.id) {
  //       let selectedLteCell = getDataFromApi?.filter((el: INrCell) => (el?.index) === params?.row?.id?.toString());
  //       if (selectedLteCell?.length > 0) {
  //         let arr = rnListData?.filter((el) => el?.id === Number(selectedLteCell[0]?.radioNode)) || [];
  //         if (arr?.length > 0 && arr[0]?.model) {
  //           setSelectedNrCellDetails(selectedLteCell[0]);
  //           if(selectedDevice?.modelName?.toLowerCase() !== "SCSN-10000-3"?.toLowerCase()) {
  //             dispatch(setSelectedRadioNodeRow(arr[0]));
  //             dispatch(setOpenRnCuDrawer(true));
  //             setRadioNodeFormData(arr[0]);
  //           } else {
  //             dispatch(setSelectedDuNode(arr[0]));
  //             setDuFormData(arr[0]);
  //             dispatch(setOpenDuDrawer(true));
  //           }
  //           setRowClicked(true);
  //         }
  //       }
  //     }
  //   } else return;
  // };

  const handleCloseButtonClicked = (value: boolean) => {
    setRowClicked(value);
  };

  const handleOnDelete = () => {
    dispatch(setConfirmDialog(DIALOGOPENFOR.NRCELL));
  };
  return (
    <>
      {openConfirmDialog === DIALOGOPENFOR.NRCELL && (
        <ConfirmDialog actionName={constStr.yesDelete} handleClickAction={deleteNrCellHandler}>
          {`Are you sure you want to delete NR Cell -  ${selectedRow?.id}?`}
        </ConfirmDialog>
      )}
      {rowClicked && isOpenRnCuDrawer && (
        <CuDrawer
          data={radioNodeFormData}
          closedButtonClicked={handleCloseButtonClicked}
          rowsData={rowsDataRns}
          cellList={selectedNrCellDetails}
          isCellDrawer={"cunrcell"}
        />
      )}
      {/* {rowClicked && isOpenDuDrawer && (
        <DUDrawer
          data={duFormData}
          closedButtonClicked={handleCloseButtonClicked}
          rowsData={rowsDataDus}
          cellList={selectedNrCellDetails}
          isCellDrawer={"dunrcell"}
        />
      )} */}

      <div
        style={{
          border: "1px solid var(--color-border)",
          borderRadius: "var(--radius)",
          padding: "18px",
          boxShadow: "var(--shadow-card)",
          backgroundColor: "var(--card)",
        }}
      >
        {nrCellRowIds?.length > 0 ? (
          <div className="pb-4">
            <div className="flex gap-2 items-center">
              <p className="text-sm text-foreground">{`${nrCellRowIds?.length} row selected`}</p>
              {permissions?.hasOpCodeGroup("manage_topology") && nrCellRowIds?.length === 1 && (
                <>
                  <Button
                    className="h-10 px-3 gap-1 font-medium text-muted-foreground bg-accent shadow-sm transition-all hover:bg-background hover:text-accent-foreground hover:shadow-[2px_2px_0px_0px_var(--border)]"
                    variant="ghost"
                    size="default"
                    onClick={handleOnDelete}
                  >
                    <Icon name="delete" size={18} />
                    Delete
                  </Button>
                  {!!actionProps && <Actions actionProps={actionProps} tableId="nrCell" />}
                </>
              )}
            </div>
          </div>
        ) : (
          <div>
            <div className="flex items-center pb-2">
              <div className="w-40">
              <RadixSelectControl
                value={statusValue}
                onValueChange={handleOnStatusSelect}
                options={statusOptions}
                placeholder="STATUS"
              />
              </div>
            </div>
          </div>
        )}
        <div>
          {isLoading && <p>Loading...</p>}
          {!isLoading && (
            <CustomDataGrid
              tableId="nrCell"
              rows={rowsData}
              columns={nrCellsColumns(rowsDataRns || [])}
              checkboxSelection={true}
              rowCount={noOfRows}
              loading={isLoading}
              disableColumnMenu={true}
              disableRowSelectionOnClick={true}
              onRowSelectionModelChange={handleOnRowSelected}
              getRowId={(row: INrCellDataGridRow) => row.id}
              rowSelectionModel={nrCellRowIds}
              onCellClick={handleCellClicked}
              isRowSelectable={() => !isOfflineDevice}
             sx={{
                "& .MuiDataGrid-virtualScroller": { overflowY: "hidden" },
                "& .MuiDataGrid-scrollbar--vertical": { display: "none" },
              }}
              fillContainer={false}
            />
          )}
        </div>
      </div>
    </>
  );
};
export default NrCells;
